import questionBtn from '../../components/Popups/questionBtn'
import closeBtn from '../../components/Popups/closeBtn'
import editBtn from "../../components/Popups/editBtn";
import formGenerator from '../../components/Forms/generators/formGenerator'
import btnsGenerator from '../../components/Forms/generators/users/btnsGenerator'
import toggleSectionsRight from '../../components/Popups/sectionToggleRight'
import copyBtn from '../../components/copyBtn'
import {tokenAndRoute} from "../utils/tokenAndRoute";
import {mapState,mapGetters,mapMutations,mapActions} from 'vuex'
import {showOverlay} from "../utils/showOverlay";

export const showMoreUsers = {
  mixins: [tokenAndRoute, showOverlay],
  components: {
    questionBtn,
    closeBtn,
    editBtn,
    formGenerator,
    btnsGenerator,
    toggleSectionsRight,
    copyBtn
  },
  data() {
    return {
      disabled: true,
      name: '',
      id: '',
      activationLink: 'https://google.com',
      type: '',
      activeSection: 'more',
    }
  },
  computed: {
    ...mapState({
      users: state => state.users.users,
      editIndex: state => state.users.editUserIndex
    }),
    ...mapGetters({
      editedUser: 'users/editedUser'
    }),
    sections() {
      return [
        {
          name: 'more',
          text: this.$t('popups.showMoreUser.sec1'),
          active: true
        },
        {
          name: 'logs',
          text: this.$t('popups.showMoreUser.sec2'),
          active: false
        }
      ]
    }
  },
  methods: {
    ...mapMutations({
      updateComponentInput: 'users/UPDATE_COMPONENT_INPUT',
      showDelConfirm: 'popups/delItem/SET_SHOW',
      setNameDel: 'popups/delItem/SET_NAME',
      setTypeDel: 'popups/delItem/SET_TYPE',
      setConfirm: 'popups/delItem/SET_CONFIRM',
      setDelIndex: 'SET_DEL_INDEX'
    }),
    ...mapActions({
      updateUserInServer: 'users/updateUser',
      updateGroupInServer: 'users/updateGroup'
    }),
    enableEdit() {
      this.disabled = false
    },
    toggleSection(button) {
      for (let i = 0; i < this.sections.length; i++) {
        this.sections[i].active = false;
        if (this.sections[i].name == button.name) {
          this.sections[i].active = true
        }
      };
      this.activeSection = button.name;
    },
    delUser() {
      this.setDelIndex(this.editIndex);
      this.setNameDel(this.name);
      this.setTypeDel(this.type);
      this.showOverlay(true);
      this.showDelConfirm(true);
    },
    repeatActivation() {
      console.log('repeat activation')
    },
    enterAsUser() {
      console.log('enter as users')
    },
    setType(type) {
      if(type == 'user') {
        return this.$t('users.user')
      } else {
        return this.$t('users.group')
      }
    },
    updateInfo() {
      let item = this.editedUser;
      this.name = `${item.first_name || item.name} ${item.second_name || ''}`;
      this.id = item.user_id || item.id;
      this.type = this.setType(item.type);
    }
  },
  beforeMount() {
    this.updateInfo();
  }
}
